import { render, staticRenderFns } from "./Livreurs.vue?vue&type=template&id=45583ff8&"
import script from "./Livreurs.vue?vue&type=script&lang=js&"
export * from "./Livreurs.vue?vue&type=script&lang=js&"
import style0 from "./Livreurs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports